import React, { FC } from 'react'
import { ComponentVideoSpotlight } from '../../../models/components/videoSpotlight'
import { ProductPageVideoContainer, VideoSpotlightContainer } from './style'

//* components
import { renderHorizontalSpotlight, renderTopSection } from './subcomponents/spotlight'
import { renderFeaturedVideoSection, renderVideoSection } from './subcomponents/videoSection'

type Props = {
  data: ComponentVideoSpotlight
  useCase?: string
}

const VideoSpotlight: FC<Props> = ({ data, useCase = '' }) => {
  if (!data) return null

  const videoSpotlightData = {
    theme: data.theme || 'Light',
    headline: data.headline || '',
    subheadline:
      typeof data.subheadline === 'string' ? data.subheadline : data.subheadline?.subheadline || '',
    body: data.body || '',
    cta: data.spotlightCta || data.cta || null,
    topPadding: data.topPadding || 'Large',
    bottomPadding: data.bottomPadding || 'Large',
    logo: {
      url: data.logo?.image?.file?.url || '',
      altText: data.logo?.altText,
    },
    video: {
      image: data.video?.image?.file?.url || '',
      altText: data.video?.altText || '',
      start: data.video?.start || '',
      animationFile: data.video?.animationFile?.file?.url || '',
      url: '',
      id: '',
      type: '',
    },
    nextVideo: data.nextVideo || [],
    nextVideoTitle: data.nextVideoTitle || '',
    useCase: data?.useCase || '',
  }

  if (data.video?.youtubeId) {
    videoSpotlightData.video.id = data.video.youtubeId
    videoSpotlightData.video.type = 'youtube'
  }

  if (data.video?.vimeoId) {
    videoSpotlightData.video.id = data.video.vimeoId
    videoSpotlightData.video.type = 'vimeo'
  }

  if (data.video?.videoUrl) {
    videoSpotlightData.video.url = data.video.videoUrl
    videoSpotlightData.video.type = 'html-video'
  }

  if (data.video?.tencentVideoUrl) {
    videoSpotlightData.video.url = data.video.tencentVideoUrl
    videoSpotlightData.video.type = 'tencent-video'
  }

  const hasTopSection =
    videoSpotlightData.logo.url || videoSpotlightData.headline || videoSpotlightData.subheadline
  const isHorizontal = useCase === 'horizontal'
  const isFeaturedVideo = useCase === 'Featured Videos'
  const displayTopSection = hasTopSection && !isFeaturedVideo
  const hasVideoData =
    videoSpotlightData.video.id ||
    videoSpotlightData.video.animationFile ||
    videoSpotlightData.video.url

  if (isHorizontal) {
    return renderHorizontalSpotlight(videoSpotlightData, isFeaturedVideo, isHorizontal)
  } else {
    return (
      <VideoSpotlightContainer
        $background={useCase === 'Resource' ? 'Light' : videoSpotlightData.theme}
        $topPadding={useCase === 'Resource' ? 'None' : videoSpotlightData.topPadding}
        $useCase={useCase}
        $isFeaturedVideo={isFeaturedVideo}
        data-cy="VideoSpotlight"
        className={videoSpotlightData.useCase === 'Full width' ? 'VideoSpotlight__Full-Width' : ''}>
        {displayTopSection && renderTopSection(videoSpotlightData, isFeaturedVideo, isHorizontal)}
        <ProductPageVideoContainer
          $bottomPadding={videoSpotlightData.bottomPadding}
          $isFeaturedVideo={isFeaturedVideo}
          className={
            videoSpotlightData.useCase === 'Full width' ? 'VideoSpotlight__Full-Width' : ''
          }>
          {hasVideoData &&
            (isFeaturedVideo
              ? renderFeaturedVideoSection(videoSpotlightData, isFeaturedVideo, isHorizontal)
              : renderVideoSection(videoSpotlightData, isFeaturedVideo, isHorizontal))}
        </ProductPageVideoContainer>
      </VideoSpotlightContainer>
    )
  }
}

export default VideoSpotlight
